/**
 * User feedback policy:
 * - Prefer on-screen status bar (see installOnScreenNotify + OnScreenStatusBar)
 * - Never surface infrastructure outages here (ConnectivityBanner owns that)
 */
import { toast } from 'react-toastify';
import i18n from '../i18n/i18n';
import { classifyApiError } from './apiErrors';
import { isApiOutage } from '../services/apiAvailability';
import { pushStatusMessage, dismissStatusMessage } from './statusMessageBus';

/**
 * Surface an API error to the user according to severity.
 * Outages are silent here — ConnectivityBanner handles them.
 */
export function notifyFromApiError(error, { fallback, toastId } = {}) {
  const classified = classifyApiError(error);

  if (classified.severity === 'silent' || classified.severity === 'banner' || classified.kind === 'outage') {
    return classified;
  }

  if (isApiOutage()) {
    return classified;
  }

  const text = classified.message
    || fallback
    || i18n.t('common.somethingWentWrong', 'Something went wrong. Please try again.');
  const opts = toastId ? { toastId } : undefined;

  if (classified.severity === 'info') {
    toast.info(text, opts);
  } else {
    toast.error(text, opts);
  }

  return classified;
}

/** Explicit on-screen status (same bus as patched toast.*). */
export function notifyStatus(type, message, options) {
  return pushStatusMessage(type, message, options);
}

export function dismissNotify(id) {
  dismissStatusMessage(id);
  try { toast.dismiss(id); } catch { /* ignore */ }
}

export default notifyFromApiError;
